import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ErrorModel } from 'src/app/models/error.model';

@Component({
  selector: 'app-error-message',
  imports: [TranslatePipe],
  templateUrl: './error-message.component.html',
  styleUrl: './error-message.component.scss',
})
export class ErrorMessageComponent {
  readonly error = input.required<ErrorModel>();
  readonly message = input<string>(null);
}
